import { IDefineCommand, ICommand } from 'core-ts-types';
import { IRegistrationActivityDatasource } from '../datasources/registration_activity_datasource';
import * as _4 from 'lodash4';

angular
  .module('capability-ng-scheduler')
  .factory(
    'registrationActivityCommand',
    (
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngRegistrationActivityDatasource: IRegistrationActivityDatasource,
      log: any
    ): ICommand => {
      return defineCommandORM('registrationActivityCommand', (deferred, termId: number): any => {
        $http({
          method: 'GET',
          url: `reg/activity/term/${termId}/`
        })
          .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            ngRegistrationActivityDatasource.clear().write(data);
            deferred.resolve();
          })
          .catch((e) => {
            log.issue('Failed to get registration errors.');
            deferred.reject(e);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration_transactions/commands/registration_activity_command.ts